import {createSelector} from 'reselect';

import {CachedTableCacheSelector, CachedTableStateSelector} from './typedef';
import {getSearchResultPath} from './utils';


export const getCachedTableResultSelector = <Data, SearchFields, SortFields, Filters>(
    dataSelector: CachedTableCacheSelector<Data>,
    stateSelector: CachedTableStateSelector<SearchFields, SortFields, Filters>,
) => (
    createSelector([
        dataSelector,
        stateSelector,
    ], (cache, cacheKeys) => {
        const cacheKey = getSearchResultPath(cacheKeys);

        return cache.find(({key}) => key === cacheKey)?.item || null;
    })
);
